import configureMockStore from 'redux-mock-store';
import thunk from 'redux-thunk';

jest.mock('../../global/axios', () => ({
    get: jest.fn(),
    post: jest.fn(),
    put: jest.fn(),
    patch: jest.fn(),
    delete: jest.fn(),
}));

jest.mock('form-data', () => {
    class RecordingFormData {
        constructor() {
            this.entries = [];
        }
        append(name, value) {
            this.entries.push([name, value]);
        }
        get(name) {
            const found = this.entries.find(([key]) => key === name);
            return found ? found[1] : null;
        }
    }
    return RecordingFormData;
});

import axios from '../../global/axios';
import {
    updatePlaylistSeriesArt,
    uploadPlaylistSeriesArt,
    fetchSeriesArtServiceTypes,
} from './billboard_actions';
import * as actionTypes from './actionTypes';

const mockStore = configureMockStore([thunk]);

describe('updatePlaylistSeriesArt (#482)', () => {
    beforeEach(() => {
        axios.patch.mockReset();
    });

    it('PATCHes /api/v2/playlists/:id with the attrs under `playlist`', async () => {
        axios.patch.mockResolvedValue({ data: { id: 7, series_art_enabled: true } });
        const store = mockStore({});
        await store.dispatch(updatePlaylistSeriesArt(7, { series_art_enabled: true }));

        expect(axios.patch).toHaveBeenCalledWith(
            '/api/v2/playlists/7',
            { playlist: { series_art_enabled: true } }
        );
        const types = store.getActions().map(a => a.type);
        expect(types).toEqual([
            actionTypes.UPDATE_PLAYLIST_SERIES_ART_START,
            actionTypes.UPDATE_PLAYLIST_SERIES_ART_SUCCESS,
        ]);
    });

    it('invokes the callback with the server payload on success', async () => {
        axios.patch.mockResolvedValue({ data: { id: 7, series_art_source: 'pco' } });
        const store = mockStore({});
        const callback = jest.fn();
        await store.dispatch(updatePlaylistSeriesArt(7, { series_art_source: 'pco', series_art_service_type_id: 3 }, callback));
        expect(callback).toHaveBeenCalledWith({ id: 7, series_art_source: 'pco' });
    });
});

describe('fetchSeriesArtServiceTypes (#482)', () => {
    beforeEach(() => {
        axios.get.mockReset();
    });

    it('GETs the org-scoped list and dispatches success', async () => {
        const types = [{ id: 1, name: 'Sunday' }];
        axios.get.mockResolvedValue({ data: types });

        const store = mockStore({});
        await store.dispatch(fetchSeriesArtServiceTypes());

        expect(axios.get).toHaveBeenCalledWith('/api/v2/playlists/series_art_service_types');
        const dispatched = store.getActions();
        expect(dispatched.map(a => a.type)).toEqual([
            actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_START,
            actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS,
        ]);
        expect(dispatched[1].details).toEqual(types);
    });
});

describe('uploadPlaylistSeriesArt (#482)', () => {
    beforeEach(() => {
        axios.get.mockReset();
        axios.post.mockReset();
        axios.patch.mockReset();
    });

    // Same direct-to-S3 shape as uploadSeriesArt / uploadMedia; we
    // exercise the FULL round-trip (signed URL -> S3 -> PATCH) so a
    // regression that skips one leg is caught.
    it('runs signed-url + S3 upload + PATCH and dispatches success', async () => {
        // Node's `crypto` object lacks `randomUUID` in older test envs.
        if (typeof global.crypto === 'undefined') {
            global.crypto = { randomUUID: () => 'local-uuid' };
        } else if (typeof global.crypto.randomUUID !== 'function') {
            global.crypto.randomUUID = () => 'local-uuid';
        }
        axios.post.mockImplementation((url) => {
            if (url.includes('/billboard/signed_urls/v2')) {
                return Promise.resolve({
                    data: {
                        key: 'billboard_uploads/uuid.jpg',
                        AWSAccessKeyId: 'k',
                        policy: 'p',
                        signature: 's',
                        content_type: 'image/jpeg',
                        cache_control: 'immutable',
                    }
                });
            }
            if (url.startsWith('https://worshipkit.s3.amazonaws.com')) {
                const xml = '<?xml version="1.0"?><PostResponse><Location>https://worshipkit.s3.amazonaws.com/billboard_uploads/uuid.jpg</Location></PostResponse>';
                return Promise.resolve({ data: xml });
            }
            return Promise.reject(new Error('unexpected post ' + url));
        });
        axios.patch.mockResolvedValue({
            data: {
                id: 7,
                series_art_source: 'upload',
                series_art_uploaded_url: 'https://worshipkit.s3.amazonaws.com/billboard_uploads/uuid.jpg',
                series_art_uploaded_filename: 'series.jpg',
            }
        });

        const file = new File(['data'], 'series.jpg', { type: 'image/jpeg' });
        const store = mockStore({});
        store.dispatch(uploadPlaylistSeriesArt(7, file));

        // Drain microtasks so signed-url -> S3 -> PATCH -> dispatch all fire.
        for (let i = 0; i < 20 && store.getActions().length < 2; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            await Promise.resolve();
        }

        // signed-url call
        expect(axios.post.mock.calls[0][0]).toBe('/billboard/signed_urls/v2');
        // S3 call
        expect(axios.post.mock.calls[1][0]).toBe('https://worshipkit.s3.amazonaws.com');
        // Final PATCH lands on the playlist with all four fields set
        expect(axios.patch).toHaveBeenCalledWith(
            '/api/v2/playlists/7',
            {
                playlist: {
                    series_art_enabled: true,
                    series_art_source: 'upload',
                    series_art_uploaded_url: 'https://worshipkit.s3.amazonaws.com/billboard_uploads/uuid.jpg',
                    series_art_uploaded_filename: 'series.jpg',
                }
            }
        );
        const types = store.getActions().map(a => a.type);
        expect(types).toEqual([
            actionTypes.UPLOAD_PLAYLIST_SERIES_ART_START,
            actionTypes.UPLOAD_PLAYLIST_SERIES_ART_SUCCESS,
        ]);
    });
});
